import { render, staticRenderFns } from "./RgObjectListItem.vue?vue&type=template&id=47df18c3&scoped=true&"
import script from "./RgObjectListItem.vue?vue&type=script&lang=js&"
export * from "./RgObjectListItem.vue?vue&type=script&lang=js&"
import style0 from "./RgObjectListItem.vue?vue&type=style&index=0&id=47df18c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47df18c3",
  null
  
)

export default component.exports